import { render, staticRenderFns } from "./SearchStaffManager.vue?vue&type=template&id=47c1c0f3&scoped=true"
import script from "./SearchStaffManager.vue?vue&type=script&lang=js"
export * from "./SearchStaffManager.vue?vue&type=script&lang=js"
import style0 from "./SearchStaffManager.vue?vue&type=style&index=0&id=47c1c0f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1c0f3",
  null
  
)

export default component.exports